<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form   label-width="140px" label-position="left">
          <el-form-item label="分类选择:">
            <el-select v-model="sympageinfo" filterable placeholder="请选择类别" @change="sympagechange">
              <el-option
                v-for="item in symtypes"
                :key="item.id.Int64"
                :label="item.typename.String"
                :value="item.id.Int64"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px" @click="addnewarticle">添加新页面</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="articles"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          width = "40px"
          label="ID">
        </el-table-column>
        <el-table-column
          prop="title.String"
          width = "280px"
          label="标题名称">
        </el-table-column>
        <el-table-column
          prop="subtitle.String"
          label="子标题">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑内容" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editarticle(scope.$index, articles)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="移除内容" placement="top-start">
              <i class="fa fa-trash-o opicon fa-lg curpointer" v-on:click="removearticle(scope.$index, articles)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="添加/编辑页面内容" :visible.sync="visztpage">
      <div class="showpcinfo">
        <el-form  label-width="150px">
          <el-row class="querypanel">
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="标题:">
                  <el-input v-model="newtitle" placeholder="请输入标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="子标题:" style="margin-left: 20px;">
                  <el-input v-model="newsubtitle" placeholder="请输入子标题"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="作者:">
                  <el-input v-model="authinfo" placeholder="请输入作者"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form   label-width="120px" label-position="left" style="margin-left: 20px;">
                <el-form-item label="分类选择:" >
                  <el-select v-model="sympageinfo" filterable placeholder="请选择类别" @change="sympagechange">
                    <el-option
                      v-for="item in symtypes"
                      :key="item.id.Int64"
                      :label="item.typename.String"
                      :value="item.id.Int64"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24" style="min-height: 400px">
              <el-form   label-width="120px" label-position="left">
                <el-form-item label="内容描述:">
                  <quill-editor
                    v-model="pagecontext"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-button style="margin-top: 20px" @click="savepagecontext">保存页面内容</el-button>
          <el-button style="margin-top: 20px" @click="lookdes">显示转义内容</el-button>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :title="selectuppathtitle" :visible.sync="visupfilepanel">
      <el-row class="showpcinfo">
        <el-col :span="12">
          <el-form  label-width="120px">
            <el-form-item label="上传资料" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                drag
                action=""
                :on-success="fnUploadSuccess"
                :headers="uploadHeaders"
                :show-file-list="true"
                :http-request="fnUploadRequest"
                :limit="files">
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="上传说明" name="1">
              <div>1、您可以上传任何类型的资料。</div>
              <div>2、上传前一定要看好上传的路径！</div>
              <div>3、上传时，上传文件下方会有上传进度。</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import * as Quill from 'quill'
import Utils from '../../util/utils'
import Video from '../../util/video'
import {quillRedefine} from 'vue-quill-editor-upload'
import {quillEditor} from 'vue-quill-editor'
var OSS = require('ali-oss')
Quill.register(Video, true)
Vue.prototype.$http = axios
var that
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{'header': 1}, {'header': 2}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{ script: 'sub' }, { script: 'super' }],
  [{'indent': '-1'}, {'indent': '+1'}],
  [{'direction': 'rtl'}],
  [{'size': ['small', false, 'large', 'huge']}],
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  [{'color': []}, {'background': []}],
  [{'font': []}],
  [{'align': []}],
  ['link', 'image', 'video'],
  ['clean']
]

export default {
  components: {quillEditor, quillRedefine},
  name: 'SymPosiumList',
  data () {
    return {
      viszttype: false,
      iffzsyinfo: '1',
      iffzsy: [{
        value: '1',
        label: '放置'
      }, {
        value: '2',
        label: '不放置'
      }],
      sympageinfo: '',
      visztpage: false,
      newtitle: '',
      newsubtitle: '',
      pagecontext: '',
      authinfo: '',
      selectuppathtitle: '',
      addtimeinfo: '',
      editorOption: {},
      activeName: ['1'],
      files: 100,
      uppercent: 0,
      uploadHeaders: {
        authorization: ''
      },
      visupfilepanel: false,
      upfiletype: 'image',
      filemodel: 'new',
      selectpageid: '',
      khid: ''
    }
  },
  created: function () {
    this.editorOption =
      {
        uploadConfig: {
          methods: 'POST',
          res: (respnse) => {
            console.log(respnse)
            return respnse.info
          }
        },
        methods: 'POST',
        size: 5100,
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
        // input点击事件  formData是提交的表单实体
        change: (formData) => {
        },
        // 设置请求头 xhr: 异步请求， formData: 表单对象
        header: (xhr, formData) => {
          // xhr.setRequestHeader('myHeader','myValue');
          // formData.append('token', '1234')
        },
        // start: function (){}
        start: () => {
        },
        end: () => {
        },
        success: () => {
          console.log('上传成功')
        },
        error: () => {
        },
        placeholder: '请在此输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                that.visupfilepanel = true
                that.selectuppathtitle = '上传图片'
                that.upfiletype = 'image'
              },
              'video': function (value) {
                that.visupfilepanel = true
                that.selectuppathtitle = '上传视频'
                that.upfiletype = 'video'
              }
            }
          }
        }
      }
  },
  mounted: function () {
    that = this
    this.khid = getCookie('cusid')
    console.log(that)
    that.selectpath = 'images/article/'
    this.$store.commit('website/setcusid', {
      'cusid': this.khid
    })
    this.$store.dispatch('website/getsptypes')
  },
  computed: {
    symtypes () {
      return this.$store.state.website.sptypes
    },
    articles () {
      return this.$store.state.website.articles
    }
  },
  methods: {
    lookdes () {
      window.console.log(escape2Html(that.pagecontext))
    },
    OnUpFileSuccess (res, file, fileList) {
      if (res.success) {
        if (this.upfiletype === 'image') {
          this.pagecontext = this.pagecontext + '<p><img src="' + res.data[0].osspath + '"></p>'
        } else if (this.upfiletype === 'video') {
          this.pagecontext = this.pagecontext + '<p> 增加的视频资料 '
          this.pagecontext = this.pagecontext + '<p><video class="videoinfo" id="videoinfo" src="' + res.data[0].osspath + '" controls="controls" loop="loop"> </video></p>'
          this.pagecontext = this.pagecontext + '</p>'
        }
      }
    },
    OnUpFileError (res) {},
    BeforeUpFileUpload (file) {},
    // 分类变更，显示文章
    sympagechange () {
      // 读取分类文章的内容
      var qstr1 = 'type =' + that.sympageinfo
      var loadarticleobj = {
        whereinfo: {String: qstr1, Valid: true}
      }
      this.$store.commit('website/setqueryarticleobj', {
        'queryarticleobj': loadarticleobj
      })
      this.$store.dispatch('website/getarticlelist')
    },
    // 打开新增文章面板
    addnewarticle () {
      this.filemodel = 'new'
      this.visztpage = true
      this.newtitle = ''
      this.newsubtitle = ''
      this.pagecontext = ''
    },
    onEditorChange ({editor, html, text}) {
      console.log('---内容改变事件---')
      console.log(html)
    },
    // 保存新的文章
    savepagecontext () {
      let addtime = Utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss') // 当前时间
      var adddata
      if (this.filemodel === 'edit') {
        adddata = {
          id: {Int64: parseInt(that.selectpageid), Valid: true},
          title: {String: that.newtitle, Valid: true},
          subtitle: {String: that.newsubtitle, Valid: true},
          context: {String: escape2Html(that.pagecontext), Valid: true},
          type: parseInt(that.sympageinfo),
          addtime: {String: that.addtimeinfo, Valid: true},
          edittime: {String: addtime, Valid: true},
          auth: {String: that.authinfo, Valid: true},
          cusid: parseInt(that.khid)
        }
      } else {
        adddata = {
          title: {String: that.newtitle, Valid: true},
          subtitle: {String: that.newsubtitle, Valid: true},
          context: {String: escape2Html(that.pagecontext), Valid: true},
          type: parseInt(that.sympageinfo),
          addtime: {String: addtime, Valid: true},
          edittime: {String: '', Valid: true},
          auth: {String: that.authinfo, Valid: true},
          cusid: parseInt(that.khid)
        }
      }
      this.$store.commit('website/setarticleobj', {
        'articleobj': adddata
      })
      var qstr1 = 'type =' + that.sympageinfo
      var loadarticleobj = {
        whereinfo: {String: qstr1, Valid: true}
      }
      this.$store.commit('website/setqueryarticleobj', {
        'queryarticleobj': loadarticleobj
      })
      this.$store.dispatch('website/addarticle', {
        success () {
          that.$message({
            type: 'success',
            message: '添加完毕!'
          })
        }
      })
    },
    // 打开编辑文章面板
    editarticle (index, data) {
      this.filemodel = 'edit'
      this.visztpage = true
      var selectdata = data[index]
      this.selectpageid = selectdata.id.Int64
      console.log(selectdata.id.Int64)
      this.newtitle = selectdata.title.String
      this.newsubtitle = selectdata.subtitle.String
      this.sympageinfo = selectdata.type
      this.pagecontext = selectdata.context.String
      this.addtimeinfo = selectdata.addtime.String
      this.authinfo = selectdata.auth.String
    },
    // 移除文章信息
    removearticle (index, data) {
      var selectdata = data[index]
      var delzt = {
        whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
      }
      this.$store.commit('website/setarticleobj', {
        'articleobj': delzt
      })
      var qstr1 = 'type =' + that.sympageinfo
      var loadarticleobj = {
        whereinfo: {String: qstr1, Valid: true}
      }
      this.$store.commit('website/setqueryarticleobj', {
        'queryarticleobj': loadarticleobj
      })
      this.$store.dispatch('website/delarticle', {
        success () {
          that.$message({
            type: 'success',
            message: '删除完毕!'
          })
        }
      })
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIaf73dyK72dHv',
          accessKeySecret: 'GRv2JMOvMC02F402r2ZHBElebVUB9v',
          bucket: 'wyzb1'
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (res, file, fileList) {
      console.log(res)
      if (res.res.status === 200) {
        var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        console.log(uppath)
        console.log(this.upfiletype)
        if (this.upfiletype === 'image') {
          this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
        } else {
          this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
        }
        console.log(this.pagecontext)
      }
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
function escape2Html (str) {
  var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
  var strtmp = str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];})
  return strtmp
}
</script>



// WEBPACK FOOTER //
// src/components/website/SymPosiumPage.vue